import { useRedesSociales } from "@/hooks/useRedesSociales";
import { redesSociales } from "@/data/redesSociales";

const socialIcons: Record<string, string> = {
  Facebook: "ri-facebook-fill",
  Instagram: "ri-instagram-fill",
  LinkedIn: "ri-linkedin-fill",
  YouTube: "ri-youtube-fill",
  X: "ri-twitter-x-fill",
};

export default function ContactoInfo() {
  const { data: redes } = useRedesSociales(redesSociales);

  return (
    <div className="flex flex-col">
      {/* Título */}
      <h2 className="text-masmed-gray-900 text-2xl md:text-3xl mb-5 md:mb-6">
        MásMed Tarapacá
      </h2>

      {/* Datos de contacto */}
      <div className="space-y-1 text-masmed-gray-700 text-sm md:text-base leading-relaxed mb-8 md:mb-10">
        <p>www.masmedtarapaca.cl</p>
        <p>contacto@masmedtarapaca.cl</p>
      </div>

      {/* Redes sociales verticales */}
      <div className="space-y-3 md:space-y-4">
        {redes.map((red) => (
          <a
            key={red.id}
            href={red.url}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-3 group cursor-pointer"
          >
            <div className="w-9 h-9 md:w-10 md:h-10 rounded-full bg-primary flex items-center justify-center text-white text-sm md:text-base flex-shrink-0 transition-transform duration-200 group-hover:scale-105">
              <i className={socialIcons[red.nombre] ?? "ri-share-line"} />
            </div>
            <span className="text-masmed-gray-800 text-sm md:text-base group-hover:text-masmed-gray-900 transition-colors"
            style={{ fontFamily: "'Arial', 'Helvetica', sans-serif", fontWeight: 600 }}>
              {red.nombre}
            </span>
          </a>
        ))}
      </div>
    </div>
  );
}